import PostSearch from './post-search';

export default PostSearch;